import { EntityId } from '@reduxjs/toolkit'

export const UserTypeEnum = {
  Driver: 2,
  ClientPortal: 70,
  Dashboard: 80,
  WebAdmin: 100,
}

export type UserType = typeof UserTypeEnum[keyof typeof UserTypeEnum]

export type Driver = {
  id: EntityId
  runIds: EntityId[]
  groupIds: EntityId[]
  login: string
  name: string
  userType: UserType
  isActive: boolean
  email?: string
  mobile?: string
  employeeNumber?: string
  managerEmail?: string
  sendEmailOnCompletion: boolean
  sendEmailOnScheduled: boolean
}
